<template>
  <div class="collection">
    <tabBar :pathName="routePageName" :toTopJobVisible="true" @toTopJobCallback="toTopJob" :allChecked="allChecked" @allCheck="allCheck" @downloadAll="downloadAll" />

    <div class="content">

      <!-- 新投递筛选项 -->
      <div class="deliveryFilter clearfix bg_fff" v-if="countOptions.total_count && routePageName!=='talentRefuseDelivery'">
        <!-- 职位筛选项 -->
        <div class="searchPositionList pr fl">
          <div class="searchPosition f_14 color_40 cursor_p flex" :class="[deliveryPositionData.job_index>-1 ? 'color_blue' : '']" v-if="myDeliveryPosition.length">
            <div class="flex1 ellipsis">{{deliveryPositionData.job_post}} </div>
            <div class="text" v-if="deliveryPositionData.status && deliveryPositionData.status!=='publish'">(下线) </div>
            <span class="iconfont iconxuanxiang-shouqi"></span>
          </div>
          <div class="listBox pa">
            <div class="list bg_fff">
              <div class="item f_14 clearfix cursor_p" :class="[deliveryPositionData.job_index === -1 ? 'color_blue font_w_b' :'color_40']" @click="searchDeliveryJobs(-1)">全部职位</div>
              <div class="item f_14 clearfix cursor_p" :class="[deliveryPositionData.job_index === index ? 'color_blue font_w_b' :'color_40']" v-for="(item,index) in myDeliveryPosition" :key="String(index)" @click="searchDeliveryJobs(index)">
                <p class="ellipsis" :class="[item.status!=='publish'?'maxWidth fl':'']">{{item.job_post}}</p>
                <p class="fl" v-if="item.status!=='publish'">(下线)</p>
              </div>
            </div>
          </div>
        </div>
        <div class="fl pr line">|</div>
        <!-- 职位筛选项 -->
        <div class="searchMoreList pr fl">
          <div class="searchPosition f_14 color_40 cursor_p" :class="[deliverySearchData.degree.length || deliverySearchData.workYear.length || deliverySearchData.school_tags.length ? 'color_blue' : '']" v-if="myDeliveryPosition.length" @mouseenter="deliveryFilterState(true)" @mouseleave="deliveryFilterState(false)" >筛选{{deliverySearchData.degree.length || deliverySearchData.workYear.length || deliverySearchData.school_tags.length ? `(${deliverySearchData.degree.length + deliverySearchData.workYear.length + deliverySearchData.school_tags.length})` : ''}} <span class="iconfont iconxuanxiang-shouqi"></span></div>
          <div class="listBox pa" v-if="showDeliveryFilter.showState" @mouseenter="deliveryFilterState(true)" @mouseleave="deliveryFilterState(false)">
            <div class="list bg_fff">

              <dl class="f_14">
                <dt class="color_40">学历</dt>
                <dd class="color_9c clearfix">
                  <div :class="['name fl color_9c cursor_p transition_2', deliveryActiveItem('selecteddegree',item)?'color_blue':'' ]" v-for="item in selectData.degree" :key="item" @click="checkDeliveryFilter('selecteddegree',item)">{{item}}</div>
                </dd>
              </dl>
              <dl class="f_14">
                <dt class="color_40">工作经验</dt>
                <dd class="color_9c clearfix">
                  <div :class="['name fl color_9c cursor_p transition_2', deliveryActiveItem('selectedeXperience',item)?'color_blue':'' ]" v-for="item in selectData.xperience" :key="item" @click="checkDeliveryFilter('selectedeXperience',item)" >{{item}}</div>
                </dd>
              </dl>
              <dl class="f_14">
                <dt class="color_40">院校</dt>
                <dd class="color_9c clearfix">
                  <div :class="['name fl color_9c cursor_p transition_2', deliveryActiveItem('selectedSchool',item)?'color_blue':'' ]" v-for="item in selectData.school" :key="item" @click="checkDeliveryFilter('selectedSchool',item)" >{{item}}</div>
                </dd>
              </dl>
              <div class="templateButtons clearfix f_14 text_center">
                <div class="saveButton fr transition_2" @click="saveDeliveryFilter">保存</div>
                <div class="cancelButton fr transition_2" @click="cancelDeliveryFilter('reset')">重置</div>
              </div>

            </div>
          </div>
        </div>
        <div class="fl pr line">|</div>
        <!-- 只看未处理 -->
        <div class="untreatedButton fl" data-growing-container>
          <el-checkbox v-model="untreatedVisible" @change="clickUntreated">只看未处理</el-checkbox>
        </div>

        <div class="hot_text pr fr cursor_p"  @click="toTopJob">
          <span class="fire">🔥</span><span class="hot_text_msg">【精准曝光】功能上线！快速获得更多人才投递</span>
        </div>

      </div>

      <!-- 右侧页面布局 -->
      <div class="loading" >
        <skeleton :skeletonType="'resumeList'" v-if="isLoading"></skeleton>
        <!-- 简历卡片列表 -->
        <resumeList @pageChange="pageChange" @getDetail="getDetail" v-if="!isLoading && countOptions.choose_count" @checkListDeliveries="checkListDeliveries" :topContentVisible="false" :downloadParamList="downloadParamList" @check="checkItem" />

        <!-- 没有数据时的显示 -->
        <template v-else-if="!isLoading && !countOptions.choose_count">
          <div class="talent_notfound bg_fff text_center">
            <img src="https://files.wondercv.com/searchResume_pc/talent_notfound.png" alt="">
            <!-- 无职位 -->
            <template v-if="countOptions.online_job_count<1 && countOptions.total_count<1">
              <div class="text f_16 color_60">
                <p>当前暂无在线职位 500万人才正在期待您发布职位</p>
              </div>
              <div class="button color_blue cursor_p f_14" @click="$router.push({path:'/talent/jobedit/create'})">去发职位</div>
            </template>
            <!-- 无投递 -->
            <template v-else-if="countOptions.total_count<1">
              <div class="text f_16 color_60">
                <p>暂未收到简历 可使用人才搜索功能发现优质人才</p>
                <p>还可以一键获取心仪人才联系方式哦</p>
              </div>
              <div class="button color_blue cursor_p f_14" @click="$router.push({path:'/talent/search'})">去搜简历</div>
            </template>
            <!-- 无数据 -->
            <div class="text f_16 color_60" v-else>
              <p>暂无匹配</p>
            </div>

          </div>
        </template>

        <!-- 付费引导入口 -->
        <!-- <div class="entrance-box"> -->
        <!--  -->
        <!--   <div class="entrance-item"> -->
        <!--     <div class="entrance-item-left"> -->
        <!--       <img src="https://files.wondercv.com/hr-pc/entrance-icons1.png" alt=""> -->
        <!--       <div class="entrance-text-box"> -->
        <!--         <h6>2021校招解决方案</h6> -->
        <!--         <p>定制专业的校园招聘解决方案，提前锁定心仪人才</p> -->
        <!--       </div> -->
        <!--     </div> -->
        <!--     <a class="entrance-item-right" href="https://mp.weixin.qq.com/s/zfVguYhX2vkdh9nJ_-aq4w" target="_blank">联系我们</a> -->
        <!--   </div> -->
        <!--  -->
        <!--   <div class="entrance-item"> -->
        <!--     <div class="entrance-item-left"> -->
        <!--       <img src="https://files.wondercv.com/hr-pc/entrance-icons2.png" alt=""> -->
        <!--       <div class="entrance-text-box"> -->
        <!--         <h6>精准曝光</h6> -->
        <!--         <p>大幅提高职位曝光，快速获得海量人才投递！</p> -->
        <!--       </div> -->
        <!--     </div> -->
        <!--     <div class="entrance-item-right" @click="toTopJob">立即曝光</div> -->
        <!--   </div> -->
        <!--  -->
        <!-- </div> -->

      </div>
    </div>

    <!-- 简历详情 -->
    <resume-detail-box v-if="showDetail"
      :notfindResume="notfindResume" type="delivery" :defaultPdfQuery="defaultPdfQuery"
      @hideDetails="hideDetails"
      @pageChange="pageChange"
      @checkListDeliveries="checkListDeliveries"
    />

    <!-- 完善信息弹层 -->
    <userinfo-tips />

    <!-- 标记不合适 -->
    <unsuitable v-if="unsuitableData.showState" @checkListDeliveries="checkListDeliveries" @hideDetails="hideDetails" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
//混入优化
import {mixinsUtils} from '@/mixins/search/utils';
// 所有接口
import actions from '@/actions/index'

import {checkUserState, get_tUser , toLogin} from '@/utils/utils';

import resumeList from '@/components/resumeList/index'

import Unsuitable from '@/components/delivery/Unsuitable'

import ResumeDetailBox from '@/components/resumeDetailBox/index'
import userinfoTips from '@/components/block/userinfoTips'
//顶部导航
import tabBar from '@/components/collection/tabBar'
import skeleton from '@/components/skeletonDiagram/index.vue'
export default {
  name: 'deliveryIndex',
  data(){
    return {
      query:{ //接口参数
        token:'',
        degree:'',
        experiences:'',
        page:1,
        page_size:15,
        status: '' //不合适列表
      },

      isLoading:true,//是否在请求列表

      showDetail:false,

      myDeliveryPosition:[], //我的职位列表
      deliveryPositionData:{ //新投递-筛选的职位
        job_index:-1,
        job_post:'全部职位',
        status:'',
        recruit_info_id:'',
      },
      deliverySearchData:{ //新投递-更多筛选项
        degree:[],
        workYear:[],
        school_tags: []
      },
      selectData: {  //下拉菜单数据
        degree: ['不限', '中专', '高中', '大专', '本科', '硕士', '博士', 'MBA'], //学历
        xperience: ['不限', '在读', '应届生', '1-3年', '3-5年', '5-10年', '10年以上'], //经验
        school: ['不限', '985', '211', '海外前100']
      },

      selecteddegree:[], //学历选中数据
      selectedeXperience:[], //经验选中数据
      selectedSchool: [],   // 院校选中数据
      showDeliveryFilter:{
        state:false, //当前状态投递职位框
        showState:false, //是否显示
        timeName:null
      },

      userJWT:{},

      unsuitableIndex:-1,//不合适数据Index

      requestState:{ //请求接口状态-暂时没用
        getDetail:false,
      },
      notfindResume:false,//是否未找到简历
      defaultPdfQuery: null, //附件简历的query
      untreatedVisible: false,
      onlineJobLength: 0, // 在线职位数
      cvCountName: 'choose_count',
      allChecked: false,   // 全选
      downloadParamList: [],   // 下载参数数组
      message: '',   // loadingMessage 实例
      reqTimer: null,   // 批量下载轮训定时器
      downloadId: '',   // 批量下载 downloadId
      // cvCount: 0
    }
  },
  computed:{
    ...mapState('block',['userInfoState', 'unsuitableData']),
    ...mapState('im',['hr_account_token']),
    ...mapState('delivery',['deliveryList','countOptions','deliveryIndex','unviewed_job_deliveries_count']),
    ...mapState('resumeDetails',[ 'routePageName', 'resumeDetailToken', 'resumeDetail', 'resumeListObj', 'listOptions', 'listPageNumber']),
    ...mapGetters('resumeDetails',[ 'getStoreResumeList'] ),

  },
  components:{
    resumeList,
    'unsuitable':Unsuitable,
    ResumeDetailBox,
    'userinfo-tips':userinfoTips,
    tabBar,
    skeleton
  },
  mixins:[mixinsUtils],
  async created(){
    this.userJWT = await get_tUser();
    //页面路由变化
    this.routerChange();
    if(this.userJWT.h_t){
      //获取职位列表
      this.getMyPosition();
    }

  },

  beforeDestroy(){
    //同步到vuex中
    this.updateDeliveryList({
      unviewed_job_deliveries_count:0,
      countOptions:{
          total_count: 0, //总数
          choose_count: 0, //当前筛选的总数
          online_job_count: 0, //职位总数
        },
    });
    //重置数据
    this.resetResumeListObj();
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState']),
    ...mapMutations('delivery',['updateDeliveryList','updateDeliveryIndex','updateCvCount']),
    ...mapMutations('resumeDetails',['updateRoutePageName', 'updateResumeDetailToken', 'updateResumeDetail', 'resetResumeListObj', 'updateResumeListObj', 'updateListOptions', 'updateResumeListObj','updateDownloadResumeInfo', 'updateShowDetailFlag', 'updateSearchResumeBasic']),
    ...mapActions('im',['addSystemCustomMessage']),
    // 批量下载简历计时器
    downloadAllTimer() {
      this.reqTimer = setInterval(() => {
        actions.resumes.downloadAllCheck(this.downloadId).then(res => {
          if (res.code === 1000) {
            let { download_url } = res.data
            if (download_url) {
              let a = document.createElement('a')
              // a.setAttribute('target', '_blank')
              a.href = download_url
              a.click()
              a.remove()
              this.$message.success('下载成功')
              this.message.close()
              // 下载完之后清空选中状态
              // this.changeAllStatus(true)
              this.downloadParamList = this.downloadParamList.map(item => {
                item.checked = false
                return item
              })
              this.allChecked = false
              clearInterval(this.reqTimer)
            }
          }
        })
      }, 5000)
    },
    // 批量下载
    downloadAll() {
      let resumes = this.downloadParamList.filter(item => item.checked)
      if (!resumes.length) {
        this.$message.error('请勾选你要下载的简历')
      } else {
        this.message = this.$message({
          message: '正在下载',
          iconClass:'el-icon-loading',
          duration:0,
        })
        actions.resumes.downloadAll({infos: resumes}).then(res => {
          if (res.code === 1000) {
            let { download_id } = res.data
            this.downloadId = download_id
            this.downloadAllTimer()
          } else {
            this.message.close()
          }
        })
      }
    },
    // 单选/反选
    checkItem(index) {
      console.log(index)
      let downloadParamList = JSON.parse(JSON.stringify(this.downloadParamList))
      this.downloadParamList = downloadParamList.map((item, idx) => {
        if (index === idx) {
          item.checked = !item.checked
        }
        return item
      })
    },
    // 全选/反选
    allCheck() {
      if (this.allChecked) {
        this.downloadParamList = this.downloadParamList.map(item => {
          item.checked = false
          return item
        })
      } else {
        this.downloadParamList = this.downloadParamList.map(item => {
          item.checked = true
          return item
        })
      }
      this.allChecked = !this.allChecked
    },

    toTopJob () {

      const { href } = this.$router.resolve({
        name: 'talentJobList',
        query: {
          origin: 'delivery'
        }
      })

      window.open(href, '_blank')

    },
    clickUntreated (flag) {
      if (flag) {
        this.query.status = 'not_view'
        this.cvCountName = 'unviewed_job_deliveries_count'
      } else {
        this.query.status = ''
        this.cvCountName = 'choose_count'
      }
      this.query.page = 1
      this.getDeliveryList()

    },
    //页面路由变化
    async routerChange(){
      //created事件触发的函数在这里写...
      let { name } = this.$route;
      let {
        page=1, //页数
        token='', //职位token
        degree='', //学历
        workYear='',//工作经验
        school_tags=''   // 院校
      } = this.$route.query;

      //更新当前路由名字
      this.updateRoutePageName(name);

      //整理工作经验
      workYear = workYear ==='不限' ? [] : workYear.split(',').filter(item=>item);
      //整理学历
      degree = degree ==='不限' ? [] : degree.split(',').filter(item=>item);
      // 整理院校
      school_tags = school_tags ==='不限' ? [] : school_tags.split(',').filter(item=>item);
      this.query.page = !page ? 1 :page;

      //存储筛选项
      this.deliverySearchData = {
        degree,
        workYear,
        school_tags
      }
      //修改query
      this.query={
        page: !page ? 1 :page,
        page_size:15,
        token,
        degree: degree.join(','),
        experiences: workYear.join(','),
        school_tags: school_tags.join(','),
        status: name==='talentRefuseDelivery' ? 'unsuited' : '',
      }
      //重置数据
      this.resetResumeListObj();

      this.isLoading = true;

      if(this.userJWT.h_t){
        //更新是否完善信息(状态库)
        let userInfo = await actions.hr_accounts.getUserinfo();
        this.toggleUserInfoState(userInfo)
      }else{
        this.toggleUserInfoState(false)
      }
      // 获取列表
      this.getList();
    },
    // 获取列表,统一入口
    async getList(){
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          this.isLoading = false;
          // this.$router.replace({name:'talentSearchIndex'});
          return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });
      if(!checkUser){
        this.isLoading = false;
        //同步到vuex中
        this.updateDeliveryList({
          unviewed_job_deliveries_count:0,
          countOptions:{
            total_count: 0, //总数
            choose_count: 0, //当前筛选的总数
            online_job_count: 0, //职位总数
          },
        });
        //重置数据
        this.resetResumeListObj();
        return ;
      }
      this.getDeliveryList();
    },
    // 获取新投递列表
    getDeliveryList(){
      //返回顶部
      scrollTo(0,0);
      actions.job_deliveries.get_job_deliveries_list(this.query).then(res=>{
        //更新当前路由名字
        this.updateRoutePageName(this.$route.name);

        this.isLoading = false;
        if(res.code === 1000){
          let { resumes, total_count, choose_count, online_job_count, unviewed_job_deliveries_count} = res.data;
          this.cvCount = res.data[this.cvCountName]
          let tokenList = []
          let downloadParamList = []
          resumes.forEach((item, index) => {
            tokenList.push(item.resume.token)
            downloadParamList.push({
              checked: false,
              job_id: item.job_id,
              user_id: item.resume.user_id
            })
          })
          this.downloadParamList = downloadParamList
          // 先加载列表数据，获取简历各个状态之后再修改一次列表数据
          // console.log(newResumes,"=====================>newResumes")
          if(this.$route.path == '/talent/delivery'){
            //同步到vuex中
            this.updateCvCount(this.cvCount)
          }else if(this.$route.path == '/talent/refuseDelivery'){}
          //检查当前分页，是否异常
          if(this.replaceURI(total_count)){
            return false;
          }

          let resumeIndex = -1;
          //判断是下一页||上一页
          if(this.listPageNumber > this.listOptions.page || this.listPageNumber < this.listOptions.page){
            resumeIndex = this.listPageNumber > this.listOptions.page ? 0 : resumes.length-1;
            this.getDetail({
              index: resumeIndex,
              item: resumes[resumeIndex],
              token: resumes[resumeIndex].resume.token,
            })
          }

          this.updateListOptions({
            page: this.query.page,
            page_size: this.query.page_size,
            resumeIndex: resumeIndex,
            total_count: res.data[this.cvCountName],
          });
          // 先同步列表  再同步简历状态
          //同步到vuex中
          this.updateDeliveryList({
            unviewed_job_deliveries_count,
            countOptions:{
              total_count, //总数
              choose_count: res.data[this.cvCountName], //当前筛选的总数
              online_job_count, //职位总数
            },
          });
          if(this.routePageName === 'talentDelivery' || this.routePageName === 'talentRefuseDelivery'){
            //同步列表数据
            this.updateResumeListObj({key:'delivery', value:resumes})
          }
          actions.resumes.get_resume_detail({token_list: tokenList}).then(detailRes => {
            if (detailRes.code === 1000) {
              let { data } = detailRes
              let newResumes = resumes.map((item, index) => {
                return {...item, ...data[index]}
              })
              // console.log(newResumes,"=====================>newResumes")
              if(this.$route.path == '/talent/delivery'){
                //同步到vuex中
                this.updateCvCount(this.cvCount)
              }else if(this.$route.path == '/talent/refuseDelivery'){}
              //检查当前分页，是否异常
              if(this.replaceURI(total_count)){
                return false;
              }

              let resumeIndex = -1;
              //判断是下一页||上一页
              if(this.listPageNumber > this.listOptions.page || this.listPageNumber < this.listOptions.page){
                resumeIndex = this.listPageNumber > this.listOptions.page ? 0 : newResumes.length-1;
                this.getDetail({
                  index: resumeIndex,
                  item: newResumes[resumeIndex],
                  token: newResumes[resumeIndex].resume.token,
                })
              }

              this.updateListOptions({
                page: this.query.page,
                page_size: this.query.page_size,
                resumeIndex: resumeIndex,
                total_count: res.data[this.cvCountName],
              });

              //同步到vuex中
              this.updateDeliveryList({
                unviewed_job_deliveries_count,
                countOptions:{
                  total_count, //总数
                  choose_count: res.data[this.cvCountName], //当前筛选的总数
                  online_job_count, //职位总数
                },
              });
              if(this.routePageName === 'talentDelivery' || this.routePageName === 'talentRefuseDelivery'){
                //同步列表数据
                this.updateResumeListObj({key:'delivery', value:newResumes})
              }
            }
          })
        }else{
          //重置数据
          this.resetResumeListObj();
          //同步到vuex中
          this.updateDeliveryList({
            unviewed_job_deliveries_count:0,
            countOptions:{
              total_count: 0, //总数
              choose_count: 0, //当前筛选的总数
              online_job_count: 0, //职位总数
            },
          });
        }
      })
    },
    //获取投递附件状态
    /*getCvAttachmentStatus(resumes, choose_count,unviewed_job_deliveries_count){
      actions.job_deliveries.get_cv_attachment_status({}).then(res=>{
        if(res.code === 1000){
          let list = res.data;
          list.forEach(item=>{
            resumes.forEach(resumesItem=>{
              if(resumesItem.resume.user_id === item.user_id && resumesItem.job_id === item.job_id){
                resumesItem.job_application_id = item.job_application_id;
                resumesItem.has_email_attachemnt = item.has_email_attachemnt;
              }
            })
          })
          this.listData = resumes;
          //同步到vuex中
          this.updateDeliveryList({
            resumes:resumes,
            unviewed_job_deliveries_count,
            total_count:choose_count
          });
        }
      })

    },*/
    // 切换分页
    pageChange(pageNo){
      this.query.page = pageNo;
      //重置数据
      // this.resetResumeListObj();

      this.isLoading = true;
      // 更新路由
      this.encodeURI();
      // 获取列表
      this.getDeliveryList();
    },
    //获取简历详情
    async getDetail(options){
      // 将列表简历的基本信息存入vuex
      this.updateSearchResumeBasic({item: options.item, recommend: true})
      //同步当前简历信息--简历下载用到
      this.updateDownloadResumeInfo(options.item)
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          // this.$router.replace({name:'talentSearchIndex'});
          return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });
      //保存当前item的index
      this.updateDeliveryIndex(options.index)

      // 保存默认附件简历query
      this.defaultPdfQuery = {
        type: 'attachment_cv',
        job_id: options.item.job_id,
        user_id: options.item.resume.user_id
      }
      // 显示骨架图loading
      this.updateShowDetailFlag(false)
      this.showDetail = true;
      actions.resume_permissions.v2resumedetails({token: options.token, job_id:options.item.job_id}).then(res=>{
        this.notfindResume = false;
        if(res.code === 80139 || res.code === 80120 || res.code === 80121){
          this.notfindResume = true;
          //显示弹层
          // this.showDetail = true;
          this.updateShowDetailFlag(true)
        }else if(res.code === 1000){
          let listItem = this.getStoreResumeList.list[options.index]
          //更新页面数据
          res.data.unsuited = listItem.unsuited;
          //更新可以聊/继续沟通状态
          res.data.im_status = listItem.im_status

          //数据同步到vuex中
          this.updateResumeDetail(res.data);

          //简历详情相关url 及 参数，用作收藏等交互
          this.updateResumeDetailToken(options.token);

          //显示弹层
          // this.showDetail = true;
          this.updateShowDetailFlag(true)

        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //隐藏详情
    hideDetails(){
      this.showDetail = false;
      //重置详情的token相关数据
      this.updateResumeDetailToken('');
      // 页面结构排序
      this.sections_position = [];
      // 其他排序
      this.others_position = [];
      document.body.style.position = 'initial'
      document.body.style.overflow = 'initial'
    },
    // 更新路由
    encodeURI(){
      let { page, token, degree, experiences, school_tags } = this.query;

      let url = window.location.origin + window.location.pathname + '?';
      //更新分页
      url+=`page=${page}&token=${token}&degree=${degree}&workYear=${experiences}&school_tags=${school_tags}`;
      history.pushState(null, null, url);
    },
    // 检测当前分页数，是否合理
    replaceURI( total_count){
      let number = Math.ceil(total_count/this.query.page_size);
      if(this.query.page > number && number!==0){
        history.replaceState(null, null, '?page=1');
        this.query.page = 1;

        this.updateResumeListObj({key:'delivery', value: this.deliveryList});

        this.isLoading = true;
        this.getList();
        return true;
      }else{
        return false;
      }
    },

    //【职位】获取职位列表
    async getMyPosition(){
      actions.job_deliveries.get_choose_jobs_list().then(res=>{
        if(res.code === 1000){
          //检查职位token是否正确
          if(this.query.token){
            res.choose_jobs && res.choose_jobs.forEach((item,index)=>{
              if(this.query.token === item.token){
                this.deliveryPositionData = {
                  job_index:index,
                  job_post:item.job_post,
                  status:item.status,
                  recruit_info_id:item.token,
                }
              }
            })
          }
          //返回有职位名称的职位
          this.myDeliveryPosition = res.choose_jobs || [];

        }
      })
    },

    //【新投递筛选】点击职位
    searchDeliveryJobs(index){
      if(index>-1){
        let item = this.myDeliveryPosition[index];
        this.deliveryPositionData = {
          job_index:index,
          job_post:item.job_post,
          status:item.status,
          recruit_info_id:item.token,
        }
      }else{
        this.deliveryPositionData = {
          job_index:-1,
          job_post:'全部职位',
          status:'',
          recruit_info_id:'',
        }
      }
      //修改query
      this.query.token = this.deliveryPositionData.recruit_info_id;
      //请求第一页
      this.pageChange(1);
    },
    //【新投递筛选】显示隐藏筛选框
    deliveryFilterState(state){
      if(state === this.showDeliveryFilter.state){
        return false;
      }
      // 保存状态
      this.showDeliveryFilter.state = state;
      //清除延迟隐藏
      clearTimeout(this.showDeliveryFilter.time);
      if(state){
        this.showDeliveryFilter.showState = state;
        let { degree, workYear, school_tags } = this.deliverySearchData;
        console.log(this.deliverySearchData,"===========>");
        this.selecteddegree = [...degree]; //学历选中数据
        this.selectedeXperience = [...workYear]; //经验选中数据
        this.selectedSchool = [...school_tags]   // 院校选中数据
      }else{
        this.showDeliveryFilter.time = setTimeout(() => {
          this.showDeliveryFilter.showState = state;
        }, 100);
      }
    },
    //判断学历,院校，工作经验 是否高亮
    deliveryActiveItem(type, item){
      if(item==='不限' && !this[type].length){
        return true
      }
      let active = false;
      this[type].forEach(sitem=>{
        if(sitem === item){
          active = true
        }
      })
      return active
    },
    //点击新投递筛选
    checkDeliveryFilter(type, item){
      let list = [...this[type]];
      if(item === '不限'){
        this[type] = [];
      }else{
        let hasItem = false;
        let hasItemIndex = 0;
        this[type].forEach((sitem, index)=>{
          if(sitem === item){
            hasItem = true
            hasItemIndex = index;
          }
        })
        if(hasItem){
          this[type].splice(hasItemIndex,1);
        }else{
          this[type].push(item);
        }
      }
    },
    //【新投递筛选】确定
    saveDeliveryFilter(){
      this.deliverySearchData = {  //下拉菜单数据
        degree: this.selecteddegree,
        workYear: this.selectedeXperience, //经验选中数据
        school_tags: this.selectedSchool
      };
      //修改query
      this.query.degree = this.selecteddegree.join(',');
      this.query.experiences = this.selectedeXperience.join(',');
      this.query.school_tags = this.selectedSchool.join(',').replace(/985\/211/g, '985,211');

      //请求第一页
      this.pageChange(1);
      this.cancelDeliveryFilter();
    },
    //【新投递筛选】取消  改为重置
    cancelDeliveryFilter(type){
      if(type === 'reset'){
        this.checkDeliveryFilter('selecteddegree','不限')
        this.checkDeliveryFilter('selectedeXperience','不限')
        this.checkDeliveryFilter('selectedSchool','不限')
        this.saveDeliveryFilter()
      }else{
        this.selecteddegree = []; //学历选中数据
        this.selectedeXperience = []; //经验选中数据
        this.selectedSchool = [];   // 院校选中数据
        this.deliveryFilterState(false)
        this.showDeliveryFilter.state = false;
        this.showDeliveryFilter.showState = false;
        clearTimeout( this.showDeliveryFilter.time);
      }

    },

    //当前是待处理，需要检测列表数据
    checkListDeliveries(unsuitableIndex){

      let deliveryList = this.getStoreResumeList.list.filter((item,index)=> index !== unsuitableIndex);
      let isLastPage = Math.ceil(this.countOptions.choose_count/15) === this.query.page;

      if(!deliveryList.length && this.countOptions.choose_count===1){
        //没有更多数据了
        //更新列表
        this.updateDeliveryList({
          unviewed_job_deliveries_count: this.unviewed_job_deliveries_count,
          countOptions:{
              total_count: this.countOptions.total_count -1, //总数
              choose_count:  this.countOptions.choose_count -1, //当前筛选的总数
              online_job_count:  this.countOptions.online_job_count -1, //职位总数
            },
        });
        //同步列表数据
        this.updateResumeListObj({key:'delivery', value:deliveryList})
      }else {
        this.query.page = isLastPage && !deliveryList.length ? this.query.page-1 : this.query.page
        // 更新路由
        this.encodeURI();
        actions.job_deliveries.get_job_deliveries_list(this.query).then(res=>{
          if(res.code === 1000){
            let { resumes, total_count, choose_count, online_job_count, unviewed_job_deliveries_count} = res.data;
            let tokenList = []
            resumes.forEach((item, index) => {
              tokenList.push(item.resume.token)
            })
            // 先同步列表  再同步简历状态
            //同步到vuex中
            this.updateDeliveryList({
              unviewed_job_deliveries_count,
              countOptions:{
                total_count, //总数
                choose_count, //当前筛选的总数
                online_job_count, //职位总数
              },
            });
            //同步列表数据
            this.updateResumeListObj({key:'delivery', value:resumes})

            this.updateListOptions({
              page: this.query.page,
              page_size: this.query.page_size,
              resumeIndex: -1,
              total_count: choose_count,
            });
            actions.resumes.get_resume_detail({token_list: tokenList}).then(detailRes => {
              if (detailRes.code === 1000) {
                let { data } = detailRes
                let newResumes = resumes.map((item, index) => {
                  return {...item, ...data[index]}
                })
                // console.log(newResumes,"=====================>newResumes")
                //同步到vuex中
                this.updateDeliveryList({
                  unviewed_job_deliveries_count,
                  countOptions:{
                    total_count, //总数
                    choose_count, //当前筛选的总数
                    online_job_count, //职位总数
                  },
                });
                //同步列表数据
                this.updateResumeListObj({key:'delivery', value:newResumes})

                this.updateListOptions({
                  page: this.query.page,
                  page_size: this.query.page_size,
                  resumeIndex: -1,
                  total_count: choose_count,
                });
              }
            })
          }else{
            //同步到vuex中
            this.updateDeliveryList({
              unviewed_job_deliveries_count:0,
              countOptions:{
                total_count: 0, //总数
                choose_count: 0, //当前筛选的总数
                online_job_count: 0, //职位总数
              },
            });
            //重置列表信息
            this.resetResumeListObj();
          }
        })
      }
    },
  },
  watch: {
    //监听路由，只要路由有变化(路径，参数等变化)都有执行下面的函数，你可以
    $route: {
      handler: function (val, oldVal) {
        this.routerChange();
        //同步到vuex中
        this.updateDeliveryList({
          unviewed_job_deliveries_count:0,
          countOptions:{
              total_count: 0, //总数
              choose_count: 0, //当前筛选的总数
              online_job_count: 0, //职位总数
            },
        });
        //同步列表数据
          this.resetResumeListObj()
      },
      deep: true
    },
    //监听分页变化
    listPageNumber:{
      handler: function (val, oldVal) {
        // 翻上一页 || 下一页
        if(val < this.listOptions.page || val > this.listOptions.page){
          this.pageChange(this.listPageNumber)
        }
      },
      deep: true
    },
  },
}
</script>
<style lang="scss" scoped>
  @import '../collection/index.scss';
  @import './index.scss';
  .deliveryFilter {
    padding: 4px 0;
  }
</style>
